(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-classes"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  var root = document.querySelector(".hx-cat");
  if (!root) return;

  var state = { grade: "all", subject: "all", search: "", day: "all", openOnly: false };
  var cards = Array.prototype.slice.call(root.querySelectorAll(".hx-card"));
  var tabs = Array.prototype.slice.call(root.querySelectorAll(".hx-cat__tab"));
  var panel = root.querySelector("#hx-cat-panel");
  var subjectSel = root.querySelector("#hx-subject");
  var countEl = root.querySelector("#hx-count");
  var emptyEl = root.querySelector("#hx-empty");

  function money(cents){
    var n = cents / 100;
    return "$" + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  // parse per-card data once
  cards.forEach(function(card){
    var parsed;
    try { parsed = JSON.parse(card.dataset.subjects || "[]"); } catch(e){ parsed = []; }
    card._subjects = Array.isArray(parsed) ? parsed : [];
    card._grades = (card.dataset.grade || "").split(/\s+/).filter(Boolean);
    card._day = card.dataset.day || "";
    // .hx-add renders only when product.available, so its presence IS availability.
    card._open = !!card.querySelector(".hx-add");
    var titleEl = card.querySelector(".hx-card__title");
    card._title = (titleEl ? titleEl.textContent : "").toLowerCase();
  });

  // build subject dropdown from the subjects actually present
  var subjSet = {};
  cards.forEach(function(c){ c._subjects.forEach(function(s){ subjSet[s] = true; }); });
  Object.keys(subjSet).sort().forEach(function(s){
    var o = document.createElement("option");
    o.value = s; o.textContent = s;
    subjectSel.appendChild(o);
  });

  var EMPTY_DEFAULT = emptyEl ? emptyEl.textContent : "";

  function applyFilters(){
    var shown = 0, shownOpen = 0;
    cards.forEach(function(card){
      var gradeOk = state.grade === "all" || card._grades.indexOf(state.grade) !== -1;
      var subjOk = state.subject === "all" || card._subjects.indexOf(state.subject) !== -1;
      var searchOk = state.search === "" || card._title.indexOf(state.search) !== -1;
      var dayOk = state.day === "all" || card._day === state.day;
      var openOk = !state.openOnly || card._open;
      var ok = gradeOk && subjOk && searchOk && dayOk && openOk;
      card.hidden = !ok;
      if (ok){ shown++; if (card._open) shownOpen++; }
    });
    // Say how many can actually be booked. Without this a parent scrolling a long
    // list of full classes never learns the toggle is worth pressing.
    var label = shown + (shown === 1 ? " class" : " classes");
    if (state.openOnly){
      countEl.textContent = label + " with open seats";
    } else if (shown > 0 && shownOpen < shown){
      countEl.textContent = label + ", " + shownOpen + " with open seats";
    } else {
      countEl.textContent = label;
    }
    if (emptyEl){
      emptyEl.textContent = state.openOnly
        ? "No open seats match that filter. Turn off \u201COpen seats only\u201D to see every class and request one."
        : EMPTY_DEFAULT;
    }
    emptyEl.hidden = shown !== 0;
  }

  function selectTab(tab){
    tabs.forEach(function(t){
      var on = t === tab;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
    });
    panel.setAttribute("aria-labelledby", tab.id);
    state.grade = tab.dataset.grade;
    applyFilters();
  }
  tabs.forEach(function(tab, i){
    tab.addEventListener("click", function(){ selectTab(tab); });
    tab.addEventListener("keydown", function(e){
      var idx = i;
      if (e.key === "ArrowRight" || e.key === "ArrowDown"){ idx = (i + 1) % tabs.length; }
      else if (e.key === "ArrowLeft" || e.key === "ArrowUp"){ idx = (i - 1 + tabs.length) % tabs.length; }
      else if (e.key === "Home"){ idx = 0; }
      else if (e.key === "End"){ idx = tabs.length - 1; }
      else { return; }
      e.preventDefault();
      tabs[idx].focus();
      selectTab(tabs[idx]);
    });
  });

  subjectSel.addEventListener("change", function(){ state.subject = subjectSel.value; applyFilters(); });

  var searchEl = root.querySelector("#hx-search");
  if (searchEl){ searchEl.addEventListener("input", function(){ state.search = searchEl.value.trim().toLowerCase(); applyFilters(); }); }

  // Scoped to .hx-cat__days on purpose: the "Open seats only" toggle borrows the
  // .hx-cat__daypill look, and an unscoped selector would treat it as a day pill
  // (clicking it would call selectDay(undefined) and hide every card).
  var dayPills = Array.prototype.slice.call(root.querySelectorAll(".hx-cat__days .hx-cat__daypill"));
  function selectDay(day){
    state.day = day;
    dayPills.forEach(function(p){ p.setAttribute("aria-pressed", p.dataset.day === day ? "true" : "false"); });
    applyFilters();
  }
  dayPills.forEach(function(p){
    p.addEventListener("click", function(){ selectDay(p.dataset.day); });
  });

  var openEl = root.querySelector("#hx-openonly");
  function setOpenOnly(on){
    state.openOnly = !!on;
    if (openEl) openEl.setAttribute("aria-pressed", state.openOnly ? "true" : "false");
    applyFilters();
  }
  if (openEl){
    openEl.addEventListener("click", function(){ setOpenOnly(!state.openOnly); });
  }

  // Deep link support: /pages/enroll?grade=elem&class=Biology
  // (the Schedule page links every class block here). Selects the grade tab,
  // then scrolls to and flashes the named class card.
  try {
    var qs = new URLSearchParams(window.location.search);
    var qGrade = qs.get("grade");
    if (qGrade){
      var qTab = null;
      tabs.forEach(function(t){ if (t.dataset.grade === qGrade) qTab = t; });
      if (qTab) selectTab(qTab);
    }
    var qDay = qs.get("day");
    if (qDay){
      var DAYMAP = { mon:"Monday", tue:"Tuesday", wed:"Wednesday", thu:"Thursday", fri:"Friday" };
      var dkey = qDay.toLowerCase().slice(0,3);
      if (DAYMAP[dkey]) selectDay(DAYMAP[dkey]);
    }
    var qOpen = qs.get("open");
    if (qOpen === "1" || qOpen === "true") setOpenOnly(true);
    var qClass = qs.get("class");
    if (qClass){
      var qcl = qClass.toLowerCase(), target = null;
      cards.forEach(function(card){ if (!target && card._title === qcl) target = card; });
      if (!target){ cards.forEach(function(card){ if (!target && card._title.indexOf(qcl) !== -1) target = card; }); }
      if (target && !target.hidden){
        setTimeout(function(){
          target.scrollIntoView({ behavior: "smooth", block: "center" });
          target.classList.add("hx-card--flash");
          setTimeout(function(){ target.classList.remove("hx-card--flash"); }, 2600);
        }, 150);
      }
    }
  } catch(e){}

  // ---- cart ----
  var cartList = root.querySelector("#hx-cart-list");
  var cartCount = root.querySelector("#hx-cart-count");
  var cartEmpty = root.querySelector("#hx-cart-empty");
  var totals = root.querySelector("#hx-cart-totals");
  var subEl = root.querySelector("#hx-sub");
  var discRow = root.querySelector("#hx-disc-row");
  var discLabel = root.querySelector("#hx-disc-label");
  var discEl = root.querySelector("#hx-disc");
  var totalEl = root.querySelector("#hx-total");
  var volNote = root.querySelector("#hx-vol-note");
  var checkoutBtn = root.querySelector("#hx-checkout");
  var msgEl = root.querySelector("#hx-cart-msg");
  var mTotal = root.querySelector("#hx-m-total");
  var mCount = root.querySelector("#hx-m-count");
  var msgTimer = null;

  function showMsg(text){
    msgEl.textContent = text; msgEl.hidden = false;
    if (msgTimer) clearTimeout(msgTimer);
    msgTimer = setTimeout(function(){ msgEl.hidden = true; }, 4000);
  }

  function renderCart(cart){
    var count = cart.item_count;
    cartCount.textContent = count + (count === 1 ? " class" : " classes");
    mCount.textContent = count + (count === 1 ? " class picked" : " classes picked");
    var mbar = root.querySelector(".hx-mcart");
    if (mbar) mbar.classList.toggle("hx-mcart--empty", count === 0);

    var qtyByVariant = {};
    cart.items.forEach(function(it){ qtyByVariant[it.variant_id] = (qtyByVariant[it.variant_id] || 0) + it.quantity; });
    Array.prototype.forEach.call(root.querySelectorAll(".hx-add"), function(btn){
      var vid = parseInt(btn.dataset.variantId, 10);
      var q = qtyByVariant[vid] || 0;
      if (q > 0){ btn.classList.add("is-added"); btn.textContent = "Add another (" + q + " in cart)"; btn.disabled = false; }
      else { btn.classList.remove("is-added"); btn.textContent = "Add to cart"; btn.disabled = false; }
    });

    cartList.innerHTML = "";
    if (count === 0){
      cartEmpty.hidden = false; totals.hidden = true; checkoutBtn.disabled = true;
      mTotal.textContent = money(0);
      return;
    }
    cartEmpty.hidden = true; totals.hidden = false; checkoutBtn.disabled = false;

    cart.items.forEach(function(it){
      var li = document.createElement("li");
      li.className = "hx-cart__item";
      var left = document.createElement("div"); left.className = "hx-cart__ileft";
      var name = document.createElement("div"); name.className = "hx-cart__iname"; name.textContent = it.product_title;
      left.appendChild(name);
      if (it.variant_title){
        var meta = document.createElement("div"); meta.className = "hx-cart__imeta"; meta.textContent = it.variant_title;
        left.appendChild(meta);
      }
      // Line item properties: the meeting time (set at add-to-cart) and the student
      // name (captured on product pages) so two same-class lines are tellable apart.
      var props = it.properties || {};
      if (props["Day & time"]){
        var whenMeta = document.createElement("div"); whenMeta.className = "hx-cart__imeta"; whenMeta.textContent = props["Day & time"];
        left.appendChild(whenMeta);
      }
      if (props["Student Name"]){
        var whoMeta = document.createElement("div"); whoMeta.className = "hx-cart__imeta"; whoMeta.textContent = "For " + props["Student Name"];
        left.appendChild(whoMeta);
      }
      var qty = document.createElement("div"); qty.className = "hx-cart__qty";
      var minus = document.createElement("button"); minus.type = "button"; minus.className = "hx-cart__qbtn"; minus.textContent = "−";
      minus.dataset.key = it.key; minus.dataset.qty = it.quantity - 1;
      minus.setAttribute("aria-label", (it.quantity <= 1 ? "Remove " : "Fewer ") + it.product_title);
      var qnum = document.createElement("span"); qnum.className = "hx-cart__qnum"; qnum.textContent = it.quantity; qnum.setAttribute("aria-label", it.quantity + " enrolled");
      var plus = document.createElement("button"); plus.type = "button"; plus.className = "hx-cart__qbtn"; plus.textContent = "+";
      plus.dataset.key = it.key; plus.dataset.qty = it.quantity + 1;
      plus.setAttribute("aria-label", "Add another " + it.product_title);
      qty.appendChild(minus); qty.appendChild(qnum); qty.appendChild(plus);
      left.appendChild(qty);
      var price = document.createElement("span"); price.className = "hx-cart__iprice"; price.textContent = money(it.final_line_price);
      var rm = document.createElement("button"); rm.type = "button"; rm.className = "hx-cart__remove";
      rm.setAttribute("aria-label", "Remove " + it.product_title); rm.textContent = "×"; rm.dataset.key = it.key;
      li.appendChild(left); li.appendChild(price); li.appendChild(rm);
      cartList.appendChild(li);
    });

    var subtotal = cart.items_subtotal_price;
    subEl.textContent = money(subtotal);
    // The family-volume discount is a LIVE Shopify automatic order discount
    // (5% at 3+ classes, 10% at 5+), so /cart.js already reflects it. Show the REAL
    // applied discount (cart.total_discount) + the discounted total so the cart
    // matches exactly what checkout will charge.
    var discount = cart.total_discount || 0;
    var afterDisc = subtotal - discount;
    // Derive the % from the REAL applied discount, never from item_count, so the
    // label can't assert a discount Shopify didn't actually apply.
    var appliedPct = (discount > 0 && subtotal > 0) ? Math.round(discount / subtotal * 100) : 0;
    if (discount > 0){
      discLabel.textContent = "Family discount (" + appliedPct + "%)";
      discEl.textContent = "-" + money(discount);
      discRow.hidden = false;
    } else {
      discRow.hidden = true;
    }
    totalEl.textContent = money(afterDisc);
    mTotal.textContent = money(afterDisc);

    // Tier nudge: only CLAIM a saving when a discount is actually applied.
    if (discount > 0){
      if (count >= 5){
        volNote.textContent = "Nice, you're saving " + appliedPct + "% on your whole order for enrolling 5 or more classes.";
      } else {
        volNote.textContent = "You're saving " + appliedPct + "% on your whole order. Add " + (5 - count) + " more to save 10%.";
      }
      volNote.hidden = false;
    } else if (count >= 1){
      var need = 3 - count;
      if (need > 0){
        volNote.textContent = "Add " + need + (need === 1 ? " more class" : " more classes") + " to save 5% on your whole order.";
        volNote.hidden = false;
      } else {
        volNote.hidden = true;
      }
    } else {
      volNote.hidden = true;
    }
  }

  function refreshCart(){
    // No internal catch: failures propagate so the caller (e.g. addToCart) can
    // re-sync the button instead of leaving it stuck disabled. Call sites that
    // need a soft failure (init) attach their own catch.
    return fetch("/cart.js", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(renderCart);
  }

  function updateHeaderBubble(){
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
    fetch(rootUrl + "?sections=cart-icon-bubble")
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data["cart-icon-bubble"];
        if (!html) return;
        var el = document.getElementById("cart-icon-bubble");
        if (!el) return;
        var tmp = document.createElement("div"); tmp.innerHTML = html;
        var fresh = tmp.querySelector("#cart-icon-bubble") || tmp.firstElementChild;
        if (fresh) el.innerHTML = fresh.innerHTML;
      }).catch(function(){});
  }

  function addToCart(variantId, btn){
    if (btn) btn.disabled = true;
    // "Day & time" rides along as a line item property so the meeting time shows
    // in the cart, at checkout, and on the order confirmation.
    var item = { id: variantId, quantity: 1 };
    if (btn && btn.dataset.when){ item.properties = { "Day & time": btn.dataset.when }; }
    fetch("/cart/add.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items:[ item ] })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(){
      return refreshCart();
    }).then(function(){
      updateHeaderBubble();
    }).catch(function(err){
      if (btn){ btn.disabled = false; btn.classList.remove("is-added"); btn.textContent = "Add to cart"; }
      showMsg((err && err.description) ? err.description : "Couldn't add that class. Please try again.");
    });
  }

  function removeItem(key){
    fetch("/cart/change.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(r){ return r.json(); })
      .then(renderCart)
      .then(updateHeaderBubble)
      .catch(function(){ showMsg("Couldn't update your cart. Please try again."); refreshCart().catch(function(){}); });
  }

  function changeQty(key, qty){
    fetch("/cart/change.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(renderCart)
      .then(updateHeaderBubble)
      .catch(function(){ showMsg("Couldn't update your cart. Please try again."); refreshCart().catch(function(){}); });
  }

  panel.addEventListener("click", function(e){
    var addBtn = e.target.closest(".hx-add");
    if (addBtn){ addToCart(parseInt(addBtn.dataset.variantId, 10), addBtn); return; }
    var waitBtn = e.target.closest(".hx-wait-open");
    if (waitBtn){ openWaitlist(waitBtn.dataset.title); return; }
  });
  root.addEventListener("click", function(e){
    var qbtn = e.target.closest(".hx-cart__qbtn");
    if (qbtn){ changeQty(qbtn.dataset.key, parseInt(qbtn.dataset.qty, 10)); return; }
    var rm = e.target.closest(".hx-cart__remove");
    if (rm){ removeItem(rm.dataset.key); }
  });
  checkoutBtn.addEventListener("click", function(){ window.location.href = "/checkout"; });

  // ---- mobile sheet ----
  var cartCol = root.querySelector(".hx-cat__cartcol");
  var backdrop = root.querySelector("#hx-backdrop");
  var openSheetBtn = root.querySelector("#hx-m-open");
  var closeSheetBtn = root.querySelector("#hx-cart-close");
  function setSheet(open){
    var was = cartCol.classList.contains("is-open");
    cartCol.classList.toggle("is-open", open);
    if (backdrop) backdrop.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (open && closeSheetBtn){ closeSheetBtn.focus(); }
    else if (!open && was && openSheetBtn){ openSheetBtn.focus(); }
  }
  if (openSheetBtn) openSheetBtn.addEventListener("click", function(){ setSheet(true); });
  if (closeSheetBtn) closeSheetBtn.addEventListener("click", function(){ setSheet(false); });
  if (backdrop) backdrop.addEventListener("click", function(){ setSheet(false); });

  // ---- waitlist modal (latent; only used by sold-out classes) ----
  var waitModal = root.querySelector("#hx-wait");
  var waitSub = root.querySelector("#hx-wait-sub");
  var waitBody = root.querySelector("#hx-wait-body");
  var waitClose = root.querySelector("#hx-wait-close");
  var waitTrigger = null;
  function openWaitlist(title){
    if (!waitModal) return;
    waitTrigger = document.activeElement;
    if (title){
      waitSub.textContent = "We'll email you if a spot opens in " + title + ".";
      if (waitBody) waitBody.value = "Class request for: " + title;
    }
    waitModal.hidden = false;
    document.body.style.overflow = "hidden";
    var email = root.querySelector("#hx-wait-email");
    if (email) email.focus();
  }
  function closeWaitlist(){
    if (!waitModal) return;
    waitModal.hidden = true;
    document.body.style.overflow = "";
    if (waitTrigger && waitTrigger.focus){ waitTrigger.focus(); }
    waitTrigger = null;
  }
  if (waitClose) waitClose.addEventListener("click", closeWaitlist);
  if (waitModal) waitModal.addEventListener("click", function(e){ if (e.target === waitModal) closeWaitlist(); });
  if (waitModal) waitModal.addEventListener("keydown", function(e){
    if (e.key !== "Tab") return;
    var f = Array.prototype.filter.call(
      waitModal.querySelectorAll("button, [href], input, select, textarea, [tabindex]"),
      function(el){ return !el.disabled && el.tabIndex !== -1 && el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  document.addEventListener("keydown", function(e){ if (e.key === "Escape"){ closeWaitlist(); setSheet(false); } });

  // ---- init ----
  applyFilters();
  refreshCart().catch(function(){ showMsg("Couldn't load your cart. Please refresh the page."); });
  var okEl = root.querySelector(".hx-wait__ok");
  if (okEl && waitModal){ waitModal.hidden = false; document.body.style.overflow = "hidden"; okEl.focus(); }
})();

  } catch(e) { console.error(e); }
})();
})();
